import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { schoolPublicurl, rules } from "../../apis/urls";
import { decode } from "html-entities";
import Userimg2 from '../../assets/userimg.png'

const EditCoaches = () => {
  const { id } = useParams(); // get id from route params
  const navigate = useNavigate();
  let tokens = localStorage.getItem('token');
  const [schoolList, setSchoolList] = useState([]);
  const [school, setSchool] = useState("");
  const [schoolError, setSchoolError] = useState(null);

  const [coachName, setCoachName] = useState("")
      const Logout = () => {
          let urole = localStorage.getItem('userrole');
          localStorage.removeItem('coachlogin');
  
  
          if(urole === 'SUPERADMIN'){
              localStorage.removeItem('token');
              localStorage.removeItem('username');
              localStorage.removeItem('userid');
              localStorage.removeItem('userrole');
              localStorage.removeItem('test_attempted')
              localStorage.removeItem('association')
              localStorage.removeItem('coachId')
  
             
              navigate("/admin")
  
          }else{
          let store = localStorage.getItem('token');
          // console.log('key',store)
          localStorage.removeItem('token');
          localStorage.removeItem('username');
          localStorage.removeItem('userid');
          localStorage.removeItem('userrole');
          localStorage.removeItem('test_attempted')
          localStorage.removeItem('association')
  
          
          navigate("/rules_list", { replace: true });
          }
          //window.location.href = "gisa/";
        }

  // fetch schools
  useEffect(() => {
    const instance = axios.create({
      baseURL: schoolPublicurl,
      timeout: 1000000,
    });

    instance
      .get("")
      .then((res) => {
        setSchoolList(res.data.data);
      })
      .catch((error) => {
        console.log("Error fetching schools:", error.message);
      });
  }, []);

  // fetch coach details (view)
  useEffect(() => {
    if (id) {
      const token = "Bearer " + localStorage.getItem("token");

      const instance = axios.create({
        baseURL: `${rules}/coachview/${id}`,
        timeout: 1000000,
        headers: { authorization: token },
      });

      instance
        .get("")
        .then((res) => {
          setSchool(res.data.data.school_id);
          setCoachName(res.data.data.firstname);
        })
        .catch((error) => {
          console.log("Error fetching coach:", error.message);
        });
    }
  }, [id]);

  // update coach (save)
  const handleUpdate = () => {
    let error = 0;

    if (!school) {
      setSchoolError("Please select a school");
      error = 1;
    } else {
      setSchoolError(null);
    }

    if (error === 0) {
      if (window.confirm("Are you sure you want to change your school?")) {
        const token = "Bearer " + localStorage.getItem("token");
        const data = { school_id: school };

        const instance = axios.create({
          baseURL: `${rules}/coachupdate/${id}`,
          timeout: 1000000,
          headers: { authorization: token },
        });

        instance
          .put("", data)
          .then(() => {
            alert("School updated successfully");
            navigate("/select_rule"); // redirect back to coaches list
          })
          .catch((error) => {
            console.log("Error updating school:", error.message);
          });
      }
    }
  };

  let resetPassword = () => {
    navigate('/reset_password')
  }

  return (
    <div className="wrapper">
      <aside className="right-side">
        {tokens ? (
          <header>
            <div className="title-and-userprofile-wrpr">
              <div></div>
              <div className="user-profile-wrpr nav navbar-nav">
                <div className="navbar-collapse">
                  <div className="navbar">
                    <ul className="nav user-profile navbar-nav ml-auto text-right">
                      <ul className="nav-item user-avatar-items dropdown">
                        <a
                          className="nav-link dropdown-toggle"
                          data-toggle="dropdown"
                          href="/aaa"
                        >
                          <div className="username-and-type">
                            <span className="loggedinuser">
                              <i className="icon-userimage"></i>{" "}
                              <span className="username">User</span>
                            </span>
                            <span className="usertype">{coachName}</span>
                          </div>
                          <div className="profile-pic">
                            <img src={Userimg2} alt="" />
                          </div>
                        </a>

                        <div className="dropdown-menu dropdown-menu-right">
                          <button
                            className="dropdown-item"
                            onClick={() => {
                              const coachId =
                                localStorage.getItem("coachid");
                              if (coachId) {
                                navigate(`/editcoaches/${coachId}`);
                              }
                            }}
                          >
                            Edit School
                          </button>
                          <button
                            className="dropdown-item"
                            onClick={resetPassword}
                          >
                            Reset Password
                          </button>
                          <button
                            onClick={Logout}
                            className="dropdown-item"
                          >
                            Logout
                          </button>
                        </div>
                      </ul>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </header>
        ) : null}

        <div className="content-area">
          <div className="page-title-wrpr">
            <div className="page-title-left-column" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <h2 className="page-title" style={{ textAlign: 'center', width: '100%' }}>
                Select a school from the dropdown to update
              </h2>
            </div>
          </div>

          <form className="needs-validation">
            <div className="form-wrpr">
              <div className="card formcard medium coachedit">
                <div className="card-body">
                  <div className="form-group">
                    <label>
                      School<span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      value={school}
                      onChange={(e) => setSchool(e.target.value)}
                      className="form-control bg-dark selctbx"
                    >
                      <option value="">Select School</option>
                      {schoolList?.map((item, index) => (
                        <option key={index} value={item.id}>
                          {decode(item.name)}
                        </option>
                      ))}
                    </select>
                    {schoolError && (
                      <div
                        className="nerrors"
                        style={{ color: "red", fontSize: "12.8px" }}
                      >
                        {schoolError}
                      </div>
                    )}
                  </div>

                  <div className="form-group text-right">
                    <button
                      className="btn btn-primary btn-gisa"
                      type="button"
                      onClick={handleUpdate}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </aside>
    </div>
  );
};

export default EditCoaches;
